module.exports = __webpack_public_path__ + "img/doctor_certificate2.97cc2ceb.jpg";